import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { setAppVersion, setNativeResult, setProducts } from "./globalSlice";

// windows에 커스텀 속성 타입 선언
declare global {
  interface Window {
    onNativeResponse: (response: any) => void;
  }
}

// 네이티브 프로토콜 응답 결과
export enum ResponseResult {
  OK = 0,
  ERROR = 1,
}

// Native Protocol Container
const NativeProtocolContainer = () => {
  const dispatch = useDispatch();

  // ===========================================================================
  // native 에서 호출되는 전역 함수
  // ===========================================================================
  const onNativeResponse = (response: any) => {
    window.postMessage({
      origin: 'native-protocol',
      response: response
    }, '*');
  }
  window.onNativeResponse = onNativeResponse;

  // ===========================================================================
  // 구글 로그인 처리
  // ===========================================================================
  const handleGoogleLogin = (idToken: any) => {
    // parsing (확인용)
    const decoded = jwtDecode(idToken);
    const userId = decoded.sub;
    console.log("userId", userId);

    // 서버 검증 필요

  }

  // ===========================================================================
  // 카카오 로그인 처리
  // ===========================================================================
  const handleKakaoLogin = (response: any) => {
    console.log("response", JSON.stringify(response));

    // response.accessToken
  }

  // ===========================================================================
  // 페이스북 로그인 처리
  // ===========================================================================
  const handleFacebookLogin = (response: any) => {
    console.log("response", JSON.stringify(response));
  }

  // ===========================================================================
  // 리워드 광고 처리
  // ===========================================================================
  const handleRewardAds = (response: any) => {
    console.log("response", JSON.stringify(response));
  }

  // ===========================================================================
  // 구매 상품 목록 조회 처리
  // ===========================================================================
  const handleGetPurchaseProductList = useCallback((response: any) => {
    console.log("response", JSON.stringify(response));
    dispatch(setProducts(JSON.parse(response.products)));
  }, [dispatch]);

  // ===========================================================================
  // 구매 상품 구매 처리
  // ===========================================================================
  const handlePurchaseProduct = (response: any) => {
    console.log("response", JSON.stringify(response));

  }

  // ===========================================================================
  // native 에서 호출되는 함수에 의해 호출되는 함수
  // ===========================================================================
  const handleNativeResponse = useCallback((e: MessageEvent) => {
    if (!e.data.hasOwnProperty('origin') || e.data.origin !== 'native-protocol') {
      return;
    }

    console.log("response", JSON.stringify(e.data));

    dispatch(setNativeResult(e.data.response));

    const response = JSON.parse(e.data.response);

    switch(response.name) {
      case 'getAppVersion':
        if(response.result === ResponseResult.OK) {
          // {"origin":"native-protocol","response":"{\"result\":0,\"version\":\"1.0 (1)\",\"name\":\"getAppVersion\"}"}
          dispatch(setAppVersion(response.version || ""));
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'googleLogin':
        if(response.result === ResponseResult.OK) {
          // {"origin":"native-protocol","response":"{\"idToken\":\"eyJhbGciOiJSUzI1NiIsImtpZCI6Ijg4MjUwM2E1ZmQ1NmU5ZjczNGRmYmE1YzUwZDdiZjQ4ZGIyODRhZTkiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiIxNDc4NTc4MTE1MjEta2xlcmVtaHVoZ2Q3dDNranZyZWlybWI3Z28zcTRoNWMuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiIxNDc4NTc4MTE1MjEta2xlcmVtaHVoZ2Q3dDNranZyZWlybWI3Z28zcTRoNWMuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMTAzODUxNDUyMzU1NDEyODY5MTkiLCJlbWFpbCI6ImRhcmtkd0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXRfaGFzaCI6IkFONVhwMm9GaDl0bGdBcVNsNGlOeEEiLCJub25jZSI6Imlvd210ZlBTT2Z0SUtXcVlIcjh5aDJ3aEw4UXdKVVFnd2pwTEFyVDZjV00iLCJuYW1lIjoiZHcga2ltIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0tFcGltcWJiR3l5X1F0bTY1aUN3elFtZ3hsRXgzM1paaWVnMmY4OTVsb3ZuWHpVV1pfPXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6ImR3IiwiZmFtaWx5X25hbWUiOiJraW0iLCJpYXQiOjE3NTE0MzcxNzgsImV4cCI6MTc1MTQ0MDc3OH0.DxQsxojXfyAVkTRRlp_KbbWagL9xiBB3MjMV0N_6Ii6fLiaTaCHAfLqRtaadIVu4PBXZp8E6bg6JlDSr_d5hOCn-gZ51cFdGPTx-z7KuP54XQY7Jv6MunmvdraWNPzq4tfMYcG4KRkQGxw6hKmsyPtujyjUpFgPH4Es4--gY6_zpbVEq5iyeEKgyX9pk9XhjmXiq7zGxDp6h1VwSMXTZSmzAkMwuOsvqrrmYfZjGaBUqe3ts3xYfgN1hoYP-wsTewrfhT9xRZmeaHihRgMWZNIywhtC8f6vmpzebHcXNM0sdPkLlrCAzkGoRe6m9gVspzvkpmxAmPHgqCq7JSYmJ9Q\",\"result\":0,\"name\":\"googleLogin\"}"}
          handleGoogleLogin(response.idToken);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'kakaoLogin':
        if(response.result === ResponseResult.OK) {
          // {"origin":"native-protocol","response":"{\"name\":\"kakaoLogin\",\"accessToken\":\"Sx_jbKP7H-P7QTj1jABLd_9nIxrAynANAAAAAQoXElUAAAGXycsHVswhKCpFsUJR\",\"result\":0}"}
          handleKakaoLogin(response);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'facebookLogin':
        if(response.result === ResponseResult.OK) {
          // {"origin":"native-protocol","response":"{\"result\":0,\"name\":\"facebookLogin\",\"accessToken\":\"EAAFDWIyUv7wBO8LI60b5magPPr5mN8VzNl6YRwFTE4P3WWashH92aC86RkkZA98bGVefx4xrZAHfD162mzNuw8ZCi7bqaA2Iz5KU88KZAXHwyGkcfDZChmb1gsWSfwcBiYGROq4nf4N4txfzQd2dq3g4daTGyNCqi58dJnowD0WfZAn5rIc8GIIoFugGJA9iboZCgZAVBqZAdODYf2iZCuHZAKLjYDSIAs2SMVu9nMDkdwcNhmaqzm7UuIkiys51ANyteUZD\"}"}
          handleFacebookLogin(response);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'rewardAds':
        if(response.result === ResponseResult.OK) {
          // {"origin":"native-protocol","response":"{\"result\":0,\"name\":\"rewardAds\",\"rewardType\":\"coins\",\"amount\":10}"}
          handleRewardAds(response);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'getPurchaseProductList':
        if(response.result === ResponseResult.OK) {
          handleGetPurchaseProductList(response);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      case 'purchaseProduct':
        if(response.result === ResponseResult.OK) {
          handlePurchaseProduct(response);
        } else {
          // 에러 처리 (response.message)
        }
        break;
      default:
        console.log('Unknown native response:', response);
    }
  }, [dispatch, handleGetPurchaseProductList]);

  // ===========================================================================
  // native 에서 호출되는 postMessage 이벤트 핸들러 처리
  // ===========================================================================
  useEffect(() => {
    window.addEventListener('message', handleNativeResponse);

    return () => {
      window.removeEventListener('message', handleNativeResponse);
    }
  }, [handleNativeResponse]);

  return null;
};

export default NativeProtocolContainer;